import { Chart as ChartJS, TimeScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Loader } from "../../components/loading/Loader";
import { ErgonomicsLeftPanel } from "./components/ErgonomicsLeftPanel";
import { ErgonomicsMainPanel } from "./components/ErgonomicsMainPanel";
import { ErgonomicsRightPanel } from "./components/ErgonomicsRightPanel";
import { ErgonomicsProvider, useErgonomicsContext } from "../../contexts/ErgonomicsContext";

ChartJS.register(TimeScale, LinearScale, BarElement, Tooltip, Legend, zoomPlugin, annotationPlugin);

const now = new Date();
const nextHour = new Date(now);
nextHour.setMinutes(0);
nextHour.setSeconds(0);
nextHour.setMilliseconds(0);
nextHour.setHours(nextHour.getHours() + 1);
const today = new Date(nextHour);
const yesterday = new Date(nextHour);
yesterday.setDate(yesterday.getDate() - 1);
const week = new Date(nextHour);
week.setDate(week.getDate() - 7);
const month = new Date(nextHour);
month.setMonth(month.getMonth() - 1);

const defaultDateRange = {
  id: 1,
  start: yesterday.getTime(),
  stop: today.getTime(),
  window: '15m',
  unit: 'minute',
  stepSize: 60,
};
/*const optionDateRange = [
  {
    id: -1,
    display_text: 'VUE DETAILLEE',
    start: 1752666000 * 1000,
    stop: (1752666900) * 1000,
    window: '15s',
    unit: 'minute',
    stepSize: 2,
  },
];*/

const liveDateRange = {
  id: 1,
  start: now.getTime() - 5 * 60 * 1000,
  stop: now.getTime(),
  window: '10s',
  unit: 'second',
  stepSize: 15,
};

/* More info about charts used in this dashboard:
 * https://www.chartjs.org/docs/latest/
 */
const getOptions = (max=10, title='REBA Score', dateRange=0, onZoom=null, phases=[]) => { return {
  maintainAspectRatio: false,
  onClick: (evt, elements, chart) => {
    if (!elements?.length || !onZoom) return;
    const { index, datasetIndex } = elements[0];
    const ds = chart.data.datasets?.[datasetIndex]?.data || [];
    if (!ds.length) return;

    // x au format { x: timestamp(ms), y: ... }
    const xCurr = ds[index]?.x;
    if (!Number.isFinite(xCurr)) return;

    const xPrev = ds[index - 1]?.x;
    const xNext = ds[index + 1]?.x;

    // bornes via milieux des segments adjacents
    const left  = Number.isFinite(xPrev) ? Math.round((xPrev + xCurr) / 2) : (Number.isFinite(xNext) ? Math.round(xCurr - (xNext - xCurr) / 2) : xCurr - 1000);
    const right = Number.isFinite(xNext) ? Math.round((xCurr + xNext) / 2) : (Number.isFinite(xPrev) ? Math.round(xCurr + (xCurr - xPrev) / 2) : xCurr + 1000);

    // sécurité: au moins 1 ms d’écart
    const start = Math.min(left, right);
    const end   = Math.max(left, right + (right === left ? 1 : 0));

    onZoom(start, end);
  },
  scales: {
    x: {
      type: 'time',
      position: 'bottom',
      offset: false,
      grid: {
        display: true,
      },
      time: {
        unit: dateRange.unit,
        displayFormats: { hour: 'MMM D, YYYY HH:mm', minute: 'HH:mm' },
      },
      ticks: {
        stepSize: dateRange.stepSize,
      },
      min: dateRange.start,
      max: dateRange.stop,
      title: {
        display: false,
        text: 'Time',
      },
    },
    y: {
      min: 0,
      // max: max,
      beginAtZero: true,
      grid: {
        display: true,
      },
      title: {
        display: true,
        text: title,
      },
      ticks: {
        stepSize: 2,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    zoom: {
      pan: false,
      zoom: {
        mode: 'x',
        drag: { enabled: true, backgroundColor: 'rgba(65, 100, 253,0.5)' },
        onZoomComplete: ({ chart }) => {
          const start = chart.scales.x.min;
          const end = chart.scales.x.max;
          console.log(onZoom, start, end);
          if (onZoom !== null)
            onZoom(start, end);
        },
      },
    },
    annotation: { annotations: phases },
  },
}; };

const donutOptions = {
  cutout: '80%',
  plugins: {
    legend: false,
  },
};

export const ErgonomicsPage = () => {
  return (
    <ErgonomicsProvider>
      <ErgonomicsLayout/>
    </ErgonomicsProvider>
  );
};

const ErgonomicsLayout = () => {

  const { fields, isLoading } = useErgonomicsContext();

  if (fields.length === 0) return <Loader />;

  return (
      <div className="flex h-full">
        {
          isLoading && <Loader category="transparent"/>
        }
        <div className="w-1/6">
          <ErgonomicsLeftPanel/>
        </div>
        <div className="w-4/6">
          <ErgonomicsMainPanel/>
        </div>
        <div className="w-1/6">
          <ErgonomicsRightPanel/>
        </div>
      </div>
  );
};
